import { combineReducers } from 'redux';
import types from './types';
import MonthlyStatementModel from 'src/model/monthlyStatement.model';
import INITIAL_STATE, { IInitialState } from 'src/store/initialState';

const getMonthlyStatementIsPending = (
  state: boolean = false,
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.GET_MONTHLY_STATEMENT_IS_PENDING:
      return payload;

    default:
      return state;
  }
};

const content = (
  state: IInitialState['monthlyStatement'] = INITIAL_STATE.monthlyStatement,
  { type, payload }: { type: string; payload: MonthlyStatementModel }
) => {
  switch (type) {
    case types.CLEAR_ALL:
      return INITIAL_STATE.monthlyStatement.content;
    case types.SET_CONTENT:
      return payload;

    default:
      return state;
  }
};

const error = (
  state: { caller: string; error: any } = { caller: '', error: null },
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.MONTHLY_STATEMENT_ERROR:
      return payload;

    default:
      return state;
  }
};

export default combineReducers({
  content,
  getMonthlyStatementIsPending,
  error
});
